import { sendToMixpanel } from '..';

const trackSearchInputInteraction = (): void => {
  sendToMixpanel('Search Input Interaction', {
    siteSection: 'Agents',
  });
};

export default trackSearchInputInteraction;
